import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";import clsx from 'clsx';
import Button from "../../Button";
import Checkbox from "../../Checkbox";
import React, { useEffect, useState } from 'react';

import colors from "../../../utils/colors";

import Tooltip from "../../Tooltip";
import { AlignmentTypes } from "../../../types/Tooltip";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { createStyles } from "./styles";
import MarketingTagsList from "../common/MarketingTagsList";
import ProductTiles from "../common/ProductTiles";
import BrowsingSingleProduct from "../BrowsingSingleProduct";
import BrowsingMultiProduct from "../BrowsingMultiProduct";
import BrowsingCardName from "../common/BrowsingCardName";

var BrowsingCard = function BrowsingCard(props) {var _context;
  var
    productLineAttributes =













    props.productLineAttributes,marketingTags = props.marketingTags,_props$portfolio = props.portfolio,portfolioId = _props$portfolio.id,portfolioName = _props$portfolio.name,products = _props$portfolio.products,marketingTagIds = _props$portfolio.marketingTagIds,onRemoveFromProposal = props.onRemoveFromProposal,onAddToProposal = props.onAddToProposal,onCompare = props.onCompare,onCompareVariants = props.onCompareVariants,onViewPlanDetails = props.onViewPlanDetails,onConfigurePortfolio = props.onConfigurePortfolio,cartItem = props.cartItem,cartId = props.cartId,selectedForCompare = props.selectedForCompare,_props$breakpoint = props.breakpoint,breakpoint = _props$breakpoint === void 0 ? 0 : _props$breakpoint,_props$className = props.className,className = _props$className === void 0 ? '' : _props$className;

  // If portfolio is added to proposal - index or null if it is not added.
  var addedToProposal = typeof (cartItem === null || cartItem === void 0 ? void 0 : cartItem.equalsWithLastUpdateBCIndex) === 'number';

  var _useState = useState(selectedForCompare),_useState2 = _slicedToArray(_useState, 2),isSelectedForCompare = _useState2[0],setIsSelectedForCompare = _useState2[1];
  var _useState3 = useState(addedToProposal),_useState4 = _slicedToArray(_useState3, 2),isPortfolioInProposal = _useState4[0],setIsPortfolioInProposal = _useState4[1];

  // update statuses if they have been changed
  useEffect(function () {
    if (isSelectedForCompare !== selectedForCompare) setIsSelectedForCompare(selectedForCompare);
  }, [selectedForCompare]);

  useEffect(function () {
    if (isPortfolioInProposal !== addedToProposal) setIsPortfolioInProposal(addedToProposal);
  }, [addedToProposal]);

  var showMobileLayoutVersion = useWindowDimensions().width <= breakpoint;

  var classes = createStyles({
    isPortfolioInProposal: isPortfolioInProposal,
    isMultiProductPortfolio: products.length > 1,
    showMobileLayoutVersion: showMobileLayoutVersion
  });

  // Actions

  var addToProposal = function addToProposal(id) {
    setIsPortfolioInProposal(true);
    onAddToProposal(id, portfolioName);
  };

  var removeFromProposal = function removeFromProposal(id) {
    setIsPortfolioInProposal(false);
    onRemoveFromProposal(id);
  };

  var onCompareChange = function onCompareChange(id) {
    onCompare(id, !isSelectedForCompare);
    setIsSelectedForCompare(!isSelectedForCompare);
  };

  // Elements of the component
  // Action elements
  var RemoveButton = function RemoveButton(productPortfolioId) {
    return /*#__PURE__*/(
      React.createElement(Button, {
        width: "15.8rem",
        type: "outlined",
        color: "custom",
        customColor: colors.red[500],
        onClick: function onClick() {
          removeFromProposal(productPortfolioId);
        },
        className: classes.cartButton }, "Remove"));




  };

  var AddToProposalButton = function AddToProposalButton(productPortfolioId) {
    return /*#__PURE__*/(
      React.createElement(Button, {
        color: "primary",
        onClick: function onClick() {
          addToProposal(productPortfolioId);
        },
        className: classes.cartButton }, "Add to proposal"));




  };

  var CompareCheckbox = function CompareCheckbox(productPortfolioId) {
    return /*#__PURE__*/(
      React.createElement(Checkbox, {
        label: "Compare",
        highlightColor: isPortfolioInProposal ? colors.green[600] : colors.blue[600],
        onChange: function onChange() {
          onCompareChange(productPortfolioId);
        },
        checked: isSelectedForCompare }));


  };

  var ViewPlanDetailsButton = function ViewPlanDetailsButton(productPortfolioId) {
    return /*#__PURE__*/(
      React.createElement(Button, {
        type: "text",
        color: isPortfolioInProposal ? 'custom' : 'primary',
        customColor: isPortfolioInProposal ? colors.green[600] : '',
        className: classes.planDetailsButton,
        onClick: function onClick() {
          onViewPlanDetails(productPortfolioId, cartId);
        } }, "View plan details"));




  };

  // Show add to proposal or remove from it buttons with message about products` versions if there is more than 1
  var ActionButtonWrapper = function ActionButtonWrapper(productPortfolioId) {var wrapperStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return /*#__PURE__*/(
      React.createElement("div", { className: clsx(classes.actionButtonWrapper, wrapperStyles) },
      isPortfolioInProposal ?
      RemoveButton(productPortfolioId) :
      AddToProposalButton(productPortfolioId),
      cartItem && (
      isPortfolioInProposal && _Object$keys(cartItem.browsingCriteria).length > 1 ||
      !isPortfolioInProposal && _Object$keys(cartItem.browsingCriteria).length > 0) && /*#__PURE__*/
      React.createElement(Tooltip, {
        label: "Click to compare product variants",
        alignment: AlignmentTypes.BOTTOM_CENTER }, /*#__PURE__*/

      React.createElement(Button, {
        type: "text",
        size: "small",
        className: classes.versionsMessage,
        color: "primary",
        onClick: function onClick() {
          onCompareVariants(portfolioId, cartId);
        } }, "Another variant added")),





      onConfigurePortfolio && /*#__PURE__*/
      React.createElement(Tooltip, {
        label:
        isPortfolioInProposal ?
        'Click to configure portfolio' :
        'Add the portfolio to the proposal to configure it',

        alignment: AlignmentTypes.BOTTOM_CENTER }, /*#__PURE__*/

      React.createElement(Button, {
        type: "text",
        size: "small",
        className: clsx(
        classes.configurePortfolioButton,
        // The 'disabled' button property isn't used because it causes incorrect behavior with the tooltip.
        !isPortfolioInProposal && classes.disabledConfigureButton),

        color: "primary",
        onClick: function onClick() {
          if (isPortfolioInProposal) onConfigurePortfolio(portfolioId);
        } }, "Configure a portfolio"))));







  };

  var ProductAttributesInfo = function ProductAttributesInfo(productAttrs, productLine) {return /*#__PURE__*/(
      React.createElement(ProductTiles, {
        productLineAttrs: productLineAttributes,
        productAttrs: productAttrs,
        productLine: productLine,
        styles: classes.planDetailsList }));};



  // Portfolio layout with multiple products
  var MultiProductsPortfolio = function MultiProductsPortfolio(productsList) {
    return /*#__PURE__*/(
      React.createElement("div", { className: clsx(classes.portfolioWrapper, className), id: portfolioId, key: portfolioId }, /*#__PURE__*/

      React.createElement("div", { className: classes.portfolioCardHeader }, /*#__PURE__*/
      React.createElement(BrowsingCardName, {
        name: portfolioName,
        wrapperStyles: classes.portfolioNameWrapper,
        isPortfolioInProposal: isPortfolioInProposal }), /*#__PURE__*/

      React.createElement(MarketingTagsList, {
        marketingTagIds: marketingTagIds,
        marketingTags: marketingTags,
        portfolioId: portfolioId,
        listStyles: classes.tags })), /*#__PURE__*/



      React.createElement("div", { className: classes.portfolioCardHeaderBottom }, /*#__PURE__*/
      React.createElement("div", { className: classes.additionalButtonsWrapper },
      CompareCheckbox(portfolioId),
      ViewPlanDetailsButton(portfolioId)),

      ActionButtonWrapper(portfolioId, classes.actionButtonRowView)), /*#__PURE__*/


      React.createElement("div", { className: classes.multiProductsList }, productsList)));


  };

  var Products = _mapInstanceProperty(_context = _sortInstanceProperty(products).call(products,
  function (a, b) {return a.imProductId > b.imProductId ? 1 : -1;})).call(_context,
  function (product) {
    // Product layout in multi product portfolio  (the view of product card is a bit different)
    if (products.length > 1) {
      return /*#__PURE__*/(
        React.createElement(BrowsingMultiProduct, {
          key: product.imProductId,
          product: product,
          isDisabled: product.disabled,
          isPortfolioInProposal: isPortfolioInProposal,
          isMultiProductPortfolio: products.length > 1,
          createProductAttributesInfo: ProductAttributesInfo,
          showMobileLayoutVersion: showMobileLayoutVersion }));


    }
    return /*#__PURE__*/(
      React.createElement(BrowsingSingleProduct, {
        key: product.imProductId,
        product: product,
        portfolioId: portfolioId,
        marketingTagIds: marketingTagIds,
        marketingTags: marketingTags,
        isPortfolioInProposal: isPortfolioInProposal,
        isMultiProductPortfolio: products.length > 1,
        createProductAttributesInfo: ProductAttributesInfo,
        createActionButtonWrapper: ActionButtonWrapper,
        createCompareCheckbox: CompareCheckbox,
        createViewPlanDetailsButton: ViewPlanDetailsButton,
        showMobileLayoutVersion: showMobileLayoutVersion,
        className: className }));


  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, products.length > 1 ? MultiProductsPortfolio(Products) : Products);
};

export default BrowsingCard;
//# sourceMappingURL=index.js.map